class UnexpectedStockOutflowStatus {
    constructor(id, estatus) {
        this.id = id;
        this.estatus = estatus;
    }
}

module.exports = UnexpectedStockOutflowStatus; 